export {};

declare global {
    interface Array<T> {
        toSorted(compareFn?: (a: T, b: T) => number): T[];
    }
    interface String {
        replaceAll(searchValue: string | RegExp, replaceValue: string): string;
    }
}

// Add toSorted to Array prototype if not already present
if (!Array.prototype.toSorted) {
    Array.prototype.toSorted = function<T>(compareFn?: (a: T, b: T) => number): T[] {
        return [...this].sort(compareFn);
    };
}

// Add replaceAll to String prototype if not already present
if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function(searchValue: string | RegExp, replaceValue: string): string {
        return this.split(searchValue).join(replaceValue);
    };
}
